import React, { useState } from "react";
import classes from './Accounts.module.css';
import sides from '../../Assets/sides.png';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import arrowdown from "../../Assets/arrowdown.png";
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation } from 'react-router-dom';
import Footer from "../../Components/Footer/Footer";


const Accounts = () => {

  const location = useLocation();
  const pageMap = {
    '/dashboard': 'Dashboard',
    '/transactions': 'Transactions',
    '/accounts': 'Accounting',
    '/reports': 'Reports',
    '/banking': 'Banking',
    '/settings': 'Settings',

  };
  const [allChecked, setAllChecked] = useState(false);
  const [checkedRows, setCheckedRows] = useState(Array(20).fill(false));

  const handleSelectAll = () => {
    const newValue = !allChecked;
    setAllChecked(newValue);
    setCheckedRows(Array(20).fill(newValue));
  };

  const handleRowCheck = (index) => {
    const updated = [...checkedRows];
    updated[index] = !updated[index];
    setCheckedRows(updated);
    setAllChecked(updated.every((val) => val));
  };

  const staticRowsMap = {
    3: {
      name: 'Bad Debts',
      category: 'Expenses',
      description: 'System Account',
      balance: 'view',
      active: true,
    },
    8: {
      name: 'Trade Receivables',
      category: 'Current Assets',
      description: 'System Account',
      balance: 'view',
      active: true,
    },
    15: {
      name: 'Owners Capital',
      category: 'Owners Equity',
      description: '',
      balance: '₦ 2,422,296.39',
      active: true,
    }
  };


  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.accountsContainer}>
        <div className={classes.actione}>
          <button className={classes.btnsr}>New Sales Invoice</button>
          <button className={classes.btnsr}>New Purchase Invoice</button>
          <button className={classes.btnsr}>All Invoices</button>
          <button className={`${classes.btnsr} ${classes.grens}`}>Product & Services</button>
        </div>

        <header className={classes.accountsHeader}>
          <h2 className={classes.headerTitle}>List of Accounts</h2>
          <div className={classes.headerActions}>
            <div className={classes.actionsLeft}>
              <button className={`${classes.btn} ${classes.green}`}>Add an Account</button>
              <button className={classes.btn}>Import Accounts</button>
              <button className={classes.btn}>Account Reporting Groups</button>
            </div>
            <div className={classes.actionsRight}>
              <div className={classes.inputWrapper}>
                <input type="text" className={classes.searchBar} placeholder="Search..." />
                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              </div>
              <div className={classes.inputWrapper}>
                <input type="text" className={classes.searchBar} placeholder="Filter..." />
                <img src={filter} alt="Filter" className={classes.inputIcon} />
              </div>
              <img src={sides} alt="Side icon" className={classes.sideIcon} />
              <button className={classes.btn}>Quick Reports ▾</button>
            </div>
          </div>
        </header>

        <div className={classes.actions}>
          <img src={arrowdown} alt="Side icon" className={classes.sideIcons} />
          <button className={`${classes.btn} ${classes.greens}`}>Actions</button>
          <button className={classes.btns}>Delete</button>
          <button className={classes.btns}>Update</button>
        </div>

        <table className={classes.accountsTable}>
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={allChecked}
                  onChange={handleSelectAll}
                />
              </th>
              <th>Name</th>
              <th>Category</th>
              <th>Account Description</th>
              <th>Balance</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {/* First static row */}
            <tr className={classes.infoRow}>
              <td></td>
              <td>Sales</td>
              <td>Sales</td>
              <td>System Account</td>
              <td  className={classes.balanceCell}>
                <button className={classes.viewBtn}>View</button>
              </td>
              <td><input type="checkbox" checked readOnly /></td>
              <td></td>
            </tr>

            {/* Dynamic rows including injected static rows */}
            {Array(20).fill(0).map((_, i) => {
              const staticRow = staticRowsMap[i];
              if (staticRow) {
                return (
                  <tr key={`static-${i}`}>
                    <td><input type="checkbox" checked={checkedRows[i]} onChange={() => handleRowCheck(i)} /></td>
                    <td>{staticRow.name}</td>
                    <td>{staticRow.category}</td>
                    <td>{staticRow.description}</td>
                    <td>
                      {staticRow.balance === 'view' ? (
                        <button className={classes.viewBtn}>view</button>
                      ) : (
                        staticRow.balance
                      )}
                    </td>
                    <td><input type="checkbox" checked readOnly /></td>
                    <td><span className={classes.actionLink}>Actions ▾</span></td>
                  </tr>
                );
              }

              return (
                <tr key={`consulting-${i}`}>
                  <td><input type="checkbox" checked={checkedRows[i]} onChange={() => handleRowCheck(i)} /></td>
                  <td className={classes.greenText}>Consulting Revenue</td>
                  <td>Sales</td>
                  <td>{i % 5 === 0 ? 'System Account' : ''}</td>
                  <td style={{textAlign:'right'}}>₦ 2,422,296.39</td>
                  <td><input type="checkbox" checked readOnly /></td>
                  <td><span className={classes.actionLink}>Actions ▾</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>


        <table className={classes.footerTable}>
          <tfoot>
            <tr>
              <td>First</td>
              <td className={`${classes.page} ${classes.activePage}`}>1</td>
              <td className={classes.page}>2</td>
              <td>Last</td>
            </tr>
          </tfoot>
        </table>

        <div className={classes.paginationDisplay}>Displaying 1 - 25 of 41</div>




      </div>
      <Footer />
    </div>
  );
};

export default Accounts;
